// 按需导入
import Vue from 'vue'
import { Checkbox, Lazyload, GridItem, Grid, SwipeItem, Swipe, Search, Button, Switch, Tabbar, TabbarItem, NavBar, Toast, Icon, Rate, ActionSheet, Dialog, Tab, Tabs } from 'vant'

Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Icon)
Vue.use(Search)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Button)
Vue.use(Switch)
Vue.use(GridItem)
Vue.use(Grid)
Vue.use(SwipeItem)
Vue.use(Swipe)
Vue.use(Lazyload)
Vue.use(Rate)
Vue.use(ActionSheet)
Vue.use(Dialog)
Vue.use(Checkbox)
